"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        date: "2019-08-05",
        premium: {
            maximum: 10,
            reserved: 3,
            taken: 5,
        },
        original: {
            maximum: 30,
            reserved: 10,
            taken: 25,
        },
        plus: {
            maximum: 50,
            reserved: 30,
            taken: 20,
        },
        vip: {
            maximum: 50,
            reserved: 30,
            taken: 20,
        },
        pro: {
            maximum: 50,
            reserved: 30,
            taken: 20,
        },
    },
    {
        date: "2019-08-12",
        premium: {
            maximum: 10,
            reserved: 2,
            taken: 10,
        },
        original: {
            maximum: 30,
            reserved: 9,
            taken: 15,
        },
        plus: {
            maximum: 50,
            reserved: 30,
            taken: 20,
        },
        vip: {
            maximum: 50,
            reserved: 30,
            taken: 20,
        },
        pro: {
            maximum: 50,
            reserved: 30,
            taken: 20,
        },
    },
    {
        date: "2019-08-19",
        premium: {
            maximum: 10,
            reserved: 10,
            taken: 5,
        },
        original: {
            maximum: 30,
            reserved: 20,
            taken: 10,
        },
        plus: {
            maximum: 50,
            reserved: 30,
            taken: 20,
        },
        vip: {
            maximum: 50,
            reserved: 30,
            taken: 20,
        },
        pro: {
            maximum: 50,
            reserved: 30,
            taken: 20,
        },
    },
];
//# sourceMappingURL=capacity.js.map